export class VerifyEmailDto {
    constructor(
        public uid: String,
        public token: String
    ) {}
}
